import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import React from "react";

// Contenido del ActionDialog; campos en dos columnas y los botones van dentro del formulario, centrados como los del diálogo
export const ModalStyled = styled.div`
  .report-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 16px;
  }

  .button-wrapper {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 24px 0 16px;
  }
`

export const ButtonExport = styled(props => <Button {...props}/>)`
    /* Sin margen propio: el hueco lo da el gap de la cabecera y el último botón llega al borde */
    margin-right: 0 !important;
`
